import Vue from "vue";
import Vuex from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";
import getters from "./getters";

import baseX from "./modules/baseX";
import panelX from "./modules/panelX";
import jobX from "./modules/jobX";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    baseX,
    panelX,
    jobX,
  },
});
